module.exports = __webpack_public_path__ + "static/media/lda.ee9c680b.svg";